document.documentElement.classList.add('hq-ready');

// Mobile menu toggle (HQ)
(function(){
  function ready(fn){
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function(){
    var btn = document.querySelector('.hq-burger');
    var menu = document.getElementById('hqMobileMenu');
    if (!btn || !menu) return;

    function setExpanded(isOpen){
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    function openMenu(){
      menu.classList.add('is-open');
      setExpanded(true);
    }

    function closeMenu(){
      menu.classList.remove('is-open');
      setExpanded(false);
    }

    btn.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      if (menu.classList.contains('is-open')) closeMenu();
      else openMenu();
    });

    // Close when tapping outside
    document.addEventListener('click', function(e){
      if (!menu.classList.contains('is-open')) return;
      if (menu.contains(e.target) || btn.contains(e.target)) return;
      closeMenu();
    });

    // Close on Escape
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape') closeMenu();
    });

    // If a menu link is clicked, close
    menu.addEventListener('click', function(e){
      var a = e.target && e.target.closest ? e.target.closest('a') : null;
      if (a) closeMenu();
    });
  });
})();
